class MainArticle {
  constructor() {
    this.articleContent = document.querySelector('.article-template__content');
    this.videos = this.articleContent.querySelectorAll('iframe');
    this.buttons = this.articleContent.querySelectorAll('a');
    
    if (this.videos.length > 0) {
      this.videos.forEach(video => {
        this.sizeVideo(video);
      })      
    }

    if (this.buttons.length > 0) {
      this.processButtons();
    }

    this.addImageClass();
    this.removeNbsp();

    this.show();
  }

  show() {
    this.articleContent.classList.remove('js-load');
  }

  sizeVideo(video) {      
    video.parentElement.classList.add('article-template__video--parent');
    video.parentElement.classList.add('section-padding-large');
    video.classList.add('article-template__video--media');
  }

  processButtons() {
    this.addButtonClass();
    this.setButtonParent();
    this.removeBr();
    this.setButtonColour();
  }

  addButtonClass() {
    const content = this.articleContent.innerHTML;
    const contentParts = content.split('==');
    const partsJoined = [];

    contentParts.forEach( part => {
      if (part.startsWith('<a') && part.endsWith('</a>')) {
        partsJoined.push(this.insertButtonClass(part))
      } else {
        partsJoined.push(part)
      }
    })

    const parsedContent = partsJoined.join('');    
    this.articleContent.innerHTML = parsedContent;
  }

  insertButtonClass(content) {
    const buttonClass = ' class="button article-button"';
    const index = content.indexOf('">') + 1;
    const parsedContent = [content.slice(0, index), buttonClass, content.slice(index)].join('');
    return parsedContent
  }

  setButtonParent() {
    const buttons = document.querySelectorAll('.article-button');
    buttons.forEach(button => {
      button.parentElement.classList.add('article-button--parent');
    })
  }

  setButtonColour() {
    const parents = document.querySelectorAll('.article-button--parent');
    const buttons = document.querySelectorAll('.article-button');

    buttons.forEach(button => {
      if (button.nextElementSibling && button.nextSibling.classList.contains('article-button')) {
        button.classList.add('button--color-peach');
      }
    })

    parents.forEach(parent => {
      if (parent.nextElementSibling && parent.nextElementSibling.classList.contains('article-button--parent')) {
        parent.classList.add('first');
        parent.querySelector('.article-button').classList.add('button--color-peach')
      }
    })
  }

  removeBr() {
    document.querySelectorAll('.article-button--parent').forEach(parent => {
      const buttons = parent.querySelectorAll('.article-button');
      
      if (buttons.length > 1) {
        parent.querySelector('br').remove();
      }
    })

    document.querySelectorAll('p').forEach( element => {
      if (element.firstChild && element.firstChild.tagName === 'BR') {
        element.firstChild.remove();
      }
    })

  }

  removeNbsp() {
    const paragraphs = document.querySelectorAll('p');

    paragraphs.forEach( paragraph => {
      if (paragraph.innerHTML === '&nbsp;') {
        paragraph.remove();
      }
    })

    // Target &nbsp; not directly wrapped in an element
    const content = this.articleContent.innerHTML.replace(/&nbsp;/g, '');
    this.articleContent.innerHTML = content;
  }

  addImageClass() {
    const paragraphs = document.querySelectorAll('p');

    paragraphs.forEach(paragraph => {
      if (paragraph.firstChild && paragraph.firstChild.tagName === 'IMG') {
        paragraph.classList.add('article-picture');
      }
    })
  }
}

new MainArticle;